// extracted by mini-css-extract-plugin
export default {"button":"styles__button___oLR_H","content":"styles__content___Xlv0H"};